module.exports = __webpack_public_path__ + "img/battery_3default.ea762cab.png";